// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__5wbQl","picker":"styles_picker__lIlpx","dropdown":"styles_dropdown__faPyT"};